/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScreeningListType } from './InternalApiScreeningListType';
import {
    InternalApiScreeningListTypeFromJSON,
    InternalApiScreeningListTypeFromJSONTyped,
    InternalApiScreeningListTypeToJSON,
    InternalApiScreeningListTypeToJSONTyped,
} from './InternalApiScreeningListType';
import type { InternalApiScreeningRecord } from './InternalApiScreeningRecord';
import {
    InternalApiScreeningRecordFromJSON,
    InternalApiScreeningRecordFromJSONTyped,
    InternalApiScreeningRecordToJSON,
    InternalApiScreeningRecordToJSONTyped,
} from './InternalApiScreeningRecord';
import type { InternalApiScreeningMatchProvider } from './InternalApiScreeningMatchProvider';
import {
    InternalApiScreeningMatchProviderFromJSON,
    InternalApiScreeningMatchProviderFromJSONTyped,
    InternalApiScreeningMatchProviderToJSON,
    InternalApiScreeningMatchProviderToJSONTyped,
} from './InternalApiScreeningMatchProvider';

/**
 * 
 * @export
 * @interface InternalApiScreeningManualSearchHit
 */
export interface InternalApiScreeningManualSearchHit {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningManualSearchHit
     */
    id: string;
    /**
     * 
     * @type {InternalApiScreeningManualSearchHitTypeEnum}
     * @memberof InternalApiScreeningManualSearchHit
     */
    type?: InternalApiScreeningManualSearchHitTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningManualSearchHit
     */
    recordDate: string;
    /**
     * 
     * @type {InternalApiScreeningListType}
     * @memberof InternalApiScreeningManualSearchHit
     */
    screeningType: InternalApiScreeningListType;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningManualSearchHit
     */
    matchData: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningManualSearchHit
     */
    highlight?: string;
    /**
     * 
     * @type {InternalApiScreeningRecord}
     * @memberof InternalApiScreeningManualSearchHit
     */
    screeningRecord?: InternalApiScreeningRecord;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningManualSearchHit
     */
    score: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScreeningManualSearchHit
     */
    sanctionList: string;
    /**
     * 
     * @type {InternalApiScreeningMatchProvider}
     * @memberof InternalApiScreeningManualSearchHit
     */
    matchProvider?: InternalApiScreeningMatchProvider;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiScreeningManualSearchHitTypeEnum {
    PERSON = 'PERSON',
    ENTITY = 'ENTITY',
    UNKNOWN = 'UNKNOWN'
}


/**
 * Check if a given object implements the InternalApiScreeningManualSearchHit interface.
 */
export function instanceOfInternalApiScreeningManualSearchHit(value: object): value is InternalApiScreeningManualSearchHit {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('recordDate' in value) || value['recordDate'] === undefined) return false;
    if (!('screeningType' in value) || value['screeningType'] === undefined) return false;
    if (!('matchData' in value) || value['matchData'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    if (!('sanctionList' in value) || value['sanctionList'] === undefined) return false;
    return true;
}

export function InternalApiScreeningManualSearchHitFromJSON(json: any): InternalApiScreeningManualSearchHit {
    return InternalApiScreeningManualSearchHitFromJSONTyped(json, false);
}

export function InternalApiScreeningManualSearchHitFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningManualSearchHit {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'recordDate': json['recordDate'],
        'screeningType': InternalApiScreeningListTypeFromJSON(json['screeningType']),
        'matchData': json['matchData'],
        'highlight': json['highlight'] == null ? undefined : json['highlight'],
        'screeningRecord': json['screeningRecord'] == null ? undefined : InternalApiScreeningRecordFromJSON(json['screeningRecord']),
        'score': json['score'],
        'sanctionList': json['sanctionList'],
        'matchProvider': json['matchProvider'] == null ? undefined : InternalApiScreeningMatchProviderFromJSON(json['matchProvider']),
    };
}

export function InternalApiScreeningManualSearchHitToJSON(json: any): InternalApiScreeningManualSearchHit {
    return InternalApiScreeningManualSearchHitToJSONTyped(json, false);
}

export function InternalApiScreeningManualSearchHitToJSONTyped(value?: InternalApiScreeningManualSearchHit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'recordDate': value['recordDate'],
        'screeningType': InternalApiScreeningListTypeToJSON(value['screeningType']),
        'matchData': value['matchData'],
        'highlight': value['highlight'],
        'screeningRecord': InternalApiScreeningRecordToJSON(value['screeningRecord']),
        'score': value['score'],
        'sanctionList': value['sanctionList'],
        'matchProvider': InternalApiScreeningMatchProviderToJSON(value['matchProvider']),
    };
}

